<template>
  <div class="claim__item claim__item--slim">
    <div
      class="event-host"
      @mouseenter.stop="showCannotEditMessage = true"
      @mouseleave.stop="showCannotEditMessage = false"
    >
      <button
        v-if="!working"
        :disabled="!isEditable"
        @click="working = true"
        class="button button--sec button--icon"
      >
        {{ getUiString(['claim_details', 'details', 'passengers', 'add_button']) }}
        <lennoc-icon image="add-passenger"></lennoc-icon>
      </button>
      <lennoc-tool-tip v-if="messageVisible" :error="true">{{ notEditableMessage }}</lennoc-tool-tip>
    </div>

    <div v-if="working" class="data-edit data-edit--gradient">
      <form-factory
        formclass="data-edit__content"
        :documentId="documentId"
        :record="currentPerson"
        :schema="fieldData"
        :layout="fieldLayout"
        :submitText="getUiString(['claim_details', 'details', 'passengers', 'add_submit'])"
        :cancelText="getUiString(['claim_details', 'details', 'passengers', 'cancel_Button'])"
        :hasError="error"
        :isPassengerRequired="currentClaim.IsPassengerAddressRequired"
        @blurfield="checkAddress"
        @submit="checkSaveSettings"
        @reset="resetForm"
        @copy-address="copyAddress"
      >
        <h2
          class="title--l"
        >{{ getUiString(['claim_details', 'details', 'passengers', 'add_title']) }}</h2>
        <div
          class="text"
        >{{ getUiString(['claim_details', 'details', 'passengers', 'add_description']) }}</div>
      </form-factory>
    </div>
    <lennoc-modal v-if="hasProblem">
      <h2 class="title--m">{{ problem.title }}</h2>
      <p>{{ problem.text }}</p>
      <base-button-group :buttons="problem.buttons" @button-click="problemClickHandler"></base-button-group>
    </lennoc-modal>
    <lennoc-spinner v-show="busy" isFullscreen="false" />
  </div>
</template>

<script>
import day from 'dayjs'
import { mapGetters } from 'vuex'
import { getFieldKeys } from '@/utils/formComposition.js'
import { getFormFields } from '@/utils/formFields'

export default {
  name: 'AddPassenger',
  props: {
    documentId: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      working: false,
      currentPerson: null,
      busy: false,
      error: false,
      errorMessage: '',
      chkPc: '',
      chkHn: '',
      hasAddressError: false,
      showCannotEditMessage: false,
      problem: {
        title: '',
        text: '',
        buttons: []
      }
    }
  },
  methods: {
    isMinor (date) {
      return (
        !!date &&
        day(date)
          .add(18, 'year')
          .isAfter(day())
      )
    },
    async checkAddress (fielddata) {
      this.currentPerson[fielddata.field] = fielddata.value
      if (this.currentPerson.PostalCode && this.currentPerson.HouseNumber) {
        if (this.currentPerson.PostalCode !== this.chkPc || this.currentPerson.HouseNumber !== this.chkHn) {
          this.chkPc = this.currentPerson.PostalCode
          this.chkHn = this.currentPerson.HouseNumber
          this.busy = true
          const result = await this.$store.dispatch('claim/findAddress', {
            postalCode: this.currentPerson.PostalCode,
            houseNumber: this.currentPerson.HouseNumber
          })
          if (result) {
            this.hasAddressError = false
            this.currentPerson = { ...this.currentPerson, StreetName: result.Street, City: result.Town }
          } else {
            this.hasAddressError = true
            this.currentPerson = { ...this.currentPerson, StreetName: '', City: '' }
          }
          this.busy = false
        }
      }
    },
    copyAddress () {
      const accountAddress = this.account
      if (accountAddress) {
        const updatedPerson = {
          ...this.currentPerson,
          City: accountAddress.City || '',
          CountryCode: accountAddress.CountryCode || '',
          HouseNumber: accountAddress.HouseNumber || '',
          HouseNumberExtension: accountAddress.HouseNumberExtension || '',
          PostalCode: accountAddress.PostalCode || '',
          StreetName: accountAddress.StreetName || ''
        }
        this.$nextTick(() => {
          this.currentPerson = updatedPerson
        })
      } else {
        console.warn('Account address data is unavailable.')
      }
    },
    resetForm () {
      this.working = false
      this.currentPerson = { ...this.passenger }
      this.busy = false
      this.error = false
      this.errorMessage = ''
      this.chkPc = ''
      this.chkHn = ''
      this.hasAddressError = false
      this.showCannotEditMessage = false
    },
    problemClickHandler (buttonId) {
      switch (buttonId) {
        case 'but_yes':
          this.saveSettings()
          break
        case 'but_hardcopy':
          this.$store.dispatch('claim/requestPoaHardcopy', {
            claimId: this.claimId,
            value: true
          })
          this.saveSettings()
          break
        case 'but_no':
          this.currentPerson.EMailAddress = ''
          break
        case 'but_email':
          this.currentPerson.EMailAddress = ''
          break
      }
      this.problem.title = ''
      this.problem.text = ''
      this.problem.buttons = []
    },
    checkSaveSettings (record) {
      this.currentPerson = { ...record }
      const emails = this.getAllEmails
      const accountEmail = this.accountEmail.toLowerCase()
      const recordEmail = this.currentPerson.EMailAddress.toLowerCase()
      if (accountEmail === recordEmail) {
        if (
          emails.filter(ea => {
            return ea === accountEmail
          }).length > 1
        ) {
          this.problem.title = this.getUiString([
            'claim_details',
            'details',
            'passenger_edit_message',
            'mailaddressAlreadyUsedTitle2'
          ])
          this.problem.text = this.getUiString([
            'claim_details',
            'details',
            'passenger_edit_message',
            'mailaddressAlreadyUsedText2'
          ])
          this.problem.buttons = [
            {
              id: 'but_email',
              text: this.getUiString([
                'claim_details',
                'details',
                'passenger_edit_message',
                'mailaddressAlreadyUsedButtonOk'
              ])
            },
            {
              id: 'but_hardcopy',
              text: this.getUiString([
                'claim_details',
                'details',
                'passenger_edit_message',
                'confirmHardcopy'
              ])
            }
          ]
        } else {
          this.problem.title = this.getUiString([
            'claim_details',
            'details',
            'passenger_edit_message',
            'mailaddressAlreadyUsedTitle'
          ])
          this.problem.text = this.getUiString([
            'claim_details',
            'details',
            'passenger_edit_message',
            'mailaddressAlreadyUsedText'
          ])
          this.problem.buttons = [
            {
              id: 'but_yes',
              text: this.getUiString([
                'claim_details',
                'details',
                'passenger_edit_message',
                'mailaddressAlreadyUsedButtonYes'
              ])
            },
            {
              id: '',
              text: this.getUiString([
                'claim_details',
                'details',
                'passenger_edit_message',
                'mailaddressAlreadyUsedButtonNo'
              ])
            }
          ]
        }
      } else {
        this.saveSettings()
      }
    },
    async saveSettings () {
      this.busy = true
      const isMinorPassenger = this.isMinor(this.currentPerson.BirthDate)
      const result = await this.$store.dispatch('claim/addPassenger', this.currentPerson)
      if (result) {
        if (isMinorPassenger) {
          this.$store.dispatch('claim/setPassengerToEdit', result.Id)
        }
        await this.$store.dispatch('claim/refreshClaim')
        this.resetForm()
      }
    }
  },
  beforeMount () {
    this.currentPerson = { ...this.passenger }
  },
  computed: {
    ...mapGetters({
      notEditableMessage: 'claim/isNotEditableMessage',
      isEditable: 'claim/isEditableByMe',
      getUiString: 'uistrings/getUiString',
      passenger: 'claim/getEmptyPerson',
      accountEmail: 'account/getAccountEmail',
      getAllEmails: 'claim/getClaimEmailAddresses',
      claimId: 'claim/claimId',
      currentClaim: 'claim/currentClaim',
      account: 'account/shadowAccount'
    }),
    hasProblem () {
      return this.problem.text !== ''
    },
    hasAddressCheck () {
      return (!!this.chkPc && !!this.chkHn) || this.hasAddressError
    },
    getErrorClass () {
      return this.error ? 'form__group--error' : ''
    },
    fieldLayout () {
      const accountEmail = this.accountEmail.toLowerCase()
      const recordEmail = this.currentPerson.EMailAddress.toLowerCase()
      let fieldKeys = []

      if (this.isMinor(this.currentPerson.BirthDate) && accountEmail !== recordEmail) {
        fieldKeys = this.hasAddressCheck
          ? getFieldKeys('extraMinorWithAddress')
          : getFieldKeys('extraMinorPassenger')
      } else if (this.currentClaim.IsPassengerAddressRequired) {
        fieldKeys = getFieldKeys('passengerAddressRequiredFields')
      } else if (!recordEmail) {
        fieldKeys = getFieldKeys('extraPassenger')
      } else {
        fieldKeys = getFieldKeys('extraPassenger')
      }

      if (!this.currentClaim.IsPassengerBirthPlaceRequired) {
        const birthPlaceKey = 'BirthPlace'

        fieldKeys = fieldKeys.map(group =>
          group.filter(field => field.trim() !== birthPlaceKey)
        )
      }
      return fieldKeys
    },

    fieldData () {
      const fields = getFormFields(this.fieldLayout)
      const requiredFields = getFieldKeys('requiredFields')
      Object.keys(fields).forEach(f => {
        const field = fields[f]
        field.required = requiredFields.indexOf(f) !== -1
      })
      return fields
    },
    messageVisible () {
      return this.showCannotEditMessage && !this.isEditable
    }
  }
}
</script>
